import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useLocation } from 'react-router-dom';
import { FormStateType } from 'types';

import {
  RegistrationConfirm,
  RegistrationForm,
  RegistrationSuccess,
} from 'containers';

import styles from './styles.module.scss';

export const RegistrationPage = () => {
  const { search } = useLocation();

  const [stateForm, setStateForm] = useState<FormStateType>('form');

  const onFormChange = useCallback((n: FormStateType) => {
    setStateForm(n);
  }, [setStateForm]);

  useEffect(() => {
    if (search.includes('code')) {
      onFormChange('confirm');
    }
  }, [search, onFormChange]);

  const component = useMemo(() => ({
    form: <RegistrationForm onChange={onFormChange} />,
    confirm: <RegistrationConfirm onChange={onFormChange} />,
    success: <RegistrationSuccess onChange={onFormChange} />,
  }), [onFormChange]);

  return (
    <div className={styles.main_container}>
      <div className={styles.main_content}>
        {component[stateForm]}
      </div>
    </div>
  );
};
